import { Box, Divider, Grid, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import * as Style from "../stall/stall-agreement/stallAgreement.style";
import AutocompleteSelect from '../../component/select/autoCompleteSelect';
import PrefixApi from '../../api/setting/prefix/prefix.api';
import InputTextField from '../../component/input/inputTextField';
import { useTranslation } from 'react-i18next';
import CustomerAgentApi from '../../api/customer-agent/customer-agent.api';
import { swalError, swalSuccess } from '../../component/notification/swal';
import ButtonCustom from '../../component/button/buttonCustom';
import { getProfile } from '../../utils/app.utils';
import { decode } from 'js-base64';
import { useHistory, useParams } from 'react-router-dom';
import { routeName } from '../../routes/routers-name';
import { imgs } from '../../constants/images';

export default function AgentDetail() {
    const { t }: any = useTranslation();
    const profile: any = JSON.parse(getProfile() || '{}')
    const { id } = useParams<any>();
    const history = useHistory();
    const isAdmin = (history.location.state as { isAdmin: boolean })?.isAdmin;
    // console.log(isAdmin, 'isAdmin')


    const [prefixOption, setPrefixOption] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [form, setForm] = useState<any>()
    const [search, setSearch] = useState<string>('')

    const getPrefixes = async () => {
        const condition: any = {
            page: 1,
            pageLimit: 10,
            status: "ACTIVE"
        };
        const res = await PrefixApi.findAll(condition);
        setPrefixOption(res.data);
    };
    const getDetail = async () => {

        const res = await CustomerAgentApi.findId(id);
        setForm(res.data.data.customer_ag);
    };
    useEffect(() => {
        getPrefixes();
        if (id) {
            getDetail()
        }
    }, []);
    const loadData = useCallback(async () => {
        let condition: any = {
            page: 1,
            pageLimit: 100
        };
        if (search) condition = { ...condition, keyword: search };

        const res = await CustomerAgentApi.search_customer(condition);

        if (res.data.status < 300) {
            console.log(res.data.data);
            setData(res?.data.data?.items);
        } else {
            setData([]);
        }
    }, [search]);

    useEffect(() => {
        loadData()
    }, [loadData])


    const handleSubmit = async () => {
        const body = {
            userId_agent: form?.userId,
            customerId_agent: form?.customerId,
            customerId: JSON.parse(decode(profile))?.customerId,
            userId: JSON.parse(decode(profile))?.userId,
            status: "ACTIVE"
        }
        await CustomerAgentApi.post(body)
            .then(async (res) => {
                if (res.status < 300) {
                    swalSuccess('เพิ่มผู้ทำการแทนเรียบร้อย', undefined, undefined, () => history.push(routeName.editProfile))

                }

            })
            .catch((error) => {
                // setIsLoading(false)
                // swalError(error?.response?.data?.errorDescription);

                swalError(error.response.data.error_description || 'อัพเดตข้อมูล ไม่สำเร็จ');
            })
    }
    return (
        <div style={{}}>
            <div className="w-100 position-relative">
                {/* {isLoading && <Loading show />} */}
                <Style.MainContainer>
                    <Style.Topic>{'เพิ่มผู้ทำการแทน'}</Style.Topic>
                    <Divider className="mx-0" />
                    <Grid spacing={2} container sx={{ marginTop: "40px" }}>
                        <Grid item xs={12} md={3}>
                            <Box
                                className="w-100 d-flex justify-content-center"
                            >
                                {/* <div {...getRootProps()}>
                <input {...getInputProps()} />
                {file ? <Style.PicRenter src={file} alt="" /> : <Style.PicRenter src={imgs.defaultAvatar} alt="" />}

              </div> */}
                                <Style.PicRenter src={imgs.defaultAvatar} alt="" />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Style.BgInformation>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography sx={{ fontSize: "18px", fontWeight: '600' }}>
                                            รายละเอียดข้อมูลส่วนบุคคล
                                        </Typography>
                                    </Grid>
                                    {!id && <Grid item xs={12} className="w-100">
                                        <AutocompleteSelect
                                            options={data}
                                            getOptionLabel={(option: any) => option?.firstname}
                                            onChange={(e, value) => {
                                                setForm(value)
                                            }}
                                            inputValue={search || ''}
                                            onInputChange={(e, val) => {
                                                setSearch(val)
                                            }}
                                            value={form || null}
                                            labelId="prefix-name"
                                            heading={t("ค้นหา")}
                                            required
                                        />
                                    </Grid>}
                                    <Grid item lg={4} xs={12} className="w-100">
                                        <AutocompleteSelect
                                            options={prefixOption}
                                            getOptionLabel={(option: any) => option?.prefixNameTh}
                                            onChange={(e, value) => {
                                                setForm({ ...form, prefixId: value?.prefixId })
                                            }}
                                            value={prefixOption?.find((item: any) => item?.prefixId === form?.prefixId) || null}
                                            labelId="prefix-name"
                                            heading={t("REGISTER.INPUT.PREFIX")}
                                            required
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12} className="w-100">
                                        <InputTextField
                                            key="name"
                                            value={form?.firstname}
                                            onchange={(e) => {
                                                setForm({ ...form, firstname: e.target.value })
                                            }}
                                            required={true}
                                            heading={t("REGISTER.INPUT.NAME")}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12} className="w-100">
                                        <InputTextField
                                            key="lastName"
                                            value={form?.lastname}
                                            onchange={(e) => {
                                                setForm({ ...form, lastname: e.target.value })
                                            }}
                                            required={true}
                                            heading={t("REGISTER.INPUT.LAST_NAME")}
                                            disabled
                                        />
                                    </Grid>

                                    <Grid item lg={6} xs={12} className="w-100">
                                        <InputTextField

                                            value={form?.idCard}
                                            onchange={(e) => {
                                                setForm({ ...form, idCard: e.target.value })
                                            }}
                                            required={true}
                                            inputProps={{
                                                maxLength: 10,
                                            }}
                                            heading={t("เลขบัตรประชาชน")}
                                            disabled
                                        />
                                    </Grid>

                                    <Grid item lg={6} xs={12} className="w-100">
                                        <InputTextField
                                            value={form?.mobilePhone}
                                            onchange={(e) => {
                                                setForm({ ...form, mobilePhone: e.target.value })
                                            }}
                                            required={true}
                                            inputProps={{
                                                maxLength: 10,
                                            }}
                                            heading={t("REGISTER.INPUT.PHONE_NUMBER")}
                                            disabled
                                        />
                                    </Grid>

                                </Grid>
                                <Grid spacing={2} container>
                                    <Grid item xs={12} md={!id ? 6 : 12}>
                                        <ButtonCustom
                                            type="submit"
                                            textButton={'กลับ'}
                                            onClick={() => {
                                                if (isAdmin) {
                                                    if(window.history.length > 0){
                                                        history.goBack();
                                                    }else{
                                                        history.push(routeName.customer)
                                                    }
                                                } else {
                                                    history.push(routeName.editProfile)
                                                }
                                            }}
                                            mode='del'
                                            btnStyle={{
                                                fontSize: "16px",
                                                width: "100%",
                                                padding: "0px",
                                                marginTop: "32px",
                                                marginBottom: "14px",
                                            }}
                                        />
                                    </Grid>
                                    {!id && <Grid item xs={12} md={6}>
                                        <ButtonCustom
                                            type="submit"
                                            disabled={!form}
                                            textButton={t("REGISTER.BUTTON.SUMMIT")}
                                            onClick={() => {
                                                handleSubmit()
                                            }}
                                            btnStyle={{
                                                fontSize: "16px",
                                                width: "100%",
                                                padding: "0px",
                                                marginTop: "32px",
                                                marginBottom: "14px",
                                            }}
                                        />
                                    </Grid>}


                                </Grid>
                            </Style.BgInformation>
                        </Grid>
                    </Grid>
                </Style.MainContainer>
            </div>

        </div>
    )
}
